import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import { MarkovState } from "server/models"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    addModal,
} from "client/store"
import { hasAccess } from "client/utils"
import {
    Link,
    TableColumn,
} from "client/components"

import EditState from "client/pages/markov/state/edit"

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editModelAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    const columns: TableColumn[] = [
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (state: MarkovState) => (
                editModelAccess
                    ? (
                        <Link
                            href="/#"
                            onClick={() => dispatch(addModal({
                                key: "editState",
                                content: <EditState stateId={state.id} />,
                            }))}
                        >
                            {state.name}
                        </Link>
                    )
                    : state.name
            ),
        },
        {
            field: "description",
            header: lang.description,
        },
        {
            field: "order",
            header: lang.order,
            sortable: true,
            cellMinWidth: "100px",
        },
    ]

    if (editModelAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
